import { useState, useEffect, KeyboardEventHandler } from 'react';
import { useStore } from '@ui/hooks/useStore';
import useKeyDown from '@ui/hooks/useKeyDown';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const useGroupDelete = (onClose: ICloseEvent['onClose']) => {
    const { groups, lang } = useStore();
    const key = useKeyDown();
    const id = groups.selectedGroupId;
    const [group] = groups.groupsList.filter((g) => g.id === id);
    const groupName = group?.name ?? '';

    const initState = {
        groupName,
    };
    const [state, setState] = useState(initState);

    const handleConfirmClick = () => {
        groups.resetServerError();
        groups.deleteGroup();
    };
    const handleBtnKeyDown: KeyboardEventHandler<HTMLElement> = (e) => {
        const { key } = e;
        if (key === 'Enter') {
            e.stopPropagation();
            e.preventDefault();
            const target = e.target as HTMLElement;
            target.click();
        }
    };
    const handlers = {
        handleConfirmClick,
        handleBtnKeyDown,
    };

    useEffect(() => {
        groups.resetServerError();
        if (groups.operationSuccess) {
            groups.resetOperationSuccess();
        }
    }, []);
    useEffect(() => {
        if (groups.operationSuccess) {
            onClose();
            groups.resetOperationSuccess();
        }
    }, [groups.operationSuccess]);
    useEffect(() => {
        switch (key) {
            case 'Escape':
                onClose();
                break;
            case 'Enter':
                handleConfirmClick();
                break;
        }
    }, [key]);
    useEffect(() => {
        if (!group && !groups.loading) onClose();
    }, [group, groups.loading]);

    return {
        groups,
        lang,
        state,
        handlers,
    };
};

export default useGroupDelete;
